import ImagePlaceholder from 'components/shared/images/image_placeholder.jpg';
import { camelizeKeys } from 'utils/humps';

export const mockedEmptyProposal = camelizeKeys({
  id: '',
  about_safari_pages: [],
  about_us_pages: [],
  account: {},
  app: {},
  approved: false,
  brand_settings: {},
  collapsed_days: false,
  confirmed: false,
  costs: {},
  costs_accept: true,
  costs_currency: {},
  created_at: '2025-04-16T15:04:03.101-04:00',
  creator: {},
  current_step: 'itinerary',
  custom_fonts: [],
  custom_styles: null,
  dashboard_preview_url: '',
  deactivated: false,
  deleted_at: null,
  details_mode: 'chronological',
  details_mode_manually_updated: true,
  emergency_contacts: [],
  filters_for_details_tab: null,
  filters_for_pages_after_costs_page: null,
  filters_for_pages_after_cover_page: null,
  filters_for_pages_after_map_page: null,
  first_viewed: false,
  guest_portal_last_available_step: null,
  itinerary_costs_page_hidden: false,
  landing: {
    pages: [
      {
        blocks: [
          {
            id: 34393368,
            available_in_basic: false,
            children: [],
            created_from_room: null,
            data: {
              title: 'THE WORLD IS A BOOK AND THOSE WHO DO NOT TRAVEL READ ONLY ONE PAGE',
              subtitle: '- Saint Augustine',
            },
            meta: {},
            type: 'cover_page',
          },
        ],
        dates_range: {
          start: null,
          end: null,
        },
        days_range: {
          start: null,
          end: null,
        },
        for_itinerary: true,
        handle: '',
        headline: '',
        hidden: false,
        id: 5522190,
        location: null,
        original_id: null,
        primary_image_coords: ['50.0', '50.0'],
        primary_image_id: 99384,
        primary_image_manual: false,
        primary_image_url: ImagePlaceholder,
        primary_image_version_1200: ImagePlaceholder,
        primary_image_version_1600: ImagePlaceholder,
        primary_image_version_2400: ImagePlaceholder,
        primary_image_version_400: ImagePlaceholder,
        primary_image_version_800: ImagePlaceholder,
        primary_image_version_email: ImagePlaceholder,
        primary_image_versions_processing_status: 'success',
        role: 'cover_page',
        schedule_type: 'dates',
        subheadline: '',
        title: '',
        title_position: null,
        travel_dates: '',
        type: 'misc',
      },
    ],
  },
  landing_config: {},
  landing_share_url: '',
  last_available_step: 'itinerary',
  misc_pages: [],
  notes: null,
  original_id: null,
  overnights: [],
  partner_agent: null,
  partner_agent_id: null,
  policies: {},
  prepared_for: null,
  schedule_type: 'dates',
  schedules: [],
  settings: {},
  share_url: '',
  shared: false,
  show_heads_up_modal: false,
  show_mobile_info: true,
  subscriptions: {},
  tags: [],
  title: 'V2',
  tour_request: {},
  tour_request_id: 180364,
  travel_brief: {
    accommodations: [],
    flights: [],
    overall: [],
  },
  travel_dates: null,
  travel_end_date: null,
  travel_start_date: null,
  trip_events: [],
  type: '',
  updated_at: '',
  way: [],
  white_labeling_on: false,
});
